import {SignResponseExtractor} from '@atlas/convertor';

export class NoopSignResponseExtractor implements SignResponseExtractor {
  public extractSignResponse(): undefined {
    return undefined;
  }
}
